import {
  IconMaterial,
  ValidIconMaterialName,
} from '@abyss/web/ui/IconMaterial';
import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

import { ButtonStyled } from './CareTeamView.styled';

export const Chips = ({
  isSelected,
  text,
  selectedWrapperStyle,
  unselectedWrapperStyle,
  commonWrapperStyle,
  count,
  selectIcon,
  onPress,
  disabled = false,
}: {
  isSelected?: boolean;
  text: string;
  selectedWrapperStyle?: any;
  unselectedWrapperStyle?: any;
  commonWrapperStyle?: any;
  count?: number;
  selectIcon?: ValidIconMaterialName | undefined;
  onPress?: () => void;
  disabled?: boolean;
}) => (
  <ButtonStyled
    cssProps={{
      isSelected,
      selectedWrapperStyle,
      unselectedWrapperStyle,
      commonWrapperStyle,
    }}
    data-auto-testid={`${text}-chip`}
    data-testid={`${text}-chip`}
    disabled={disabled}
    onClick={onPress}
    size="$md"
    variant="outline"
  >
    <Layout.Group>
      {isSelected && (
        <IconMaterial
          color="$darkBlue"
          data-auto-testid={'check-icon'}
          data-testid={'check-icon'}
          icon={selectIcon ?? 'check'}
          size={16}
          variant="outlined"
        />
      )}
      <Text
        color={disabled ? '$gray5' : isSelected ? '$darkBlue' : '$blue'}
        data-auto-testid={`chip-${text}`}
        data-testid={`chip-${text}`}
        fontWeight="$semibold"
        size="$sm"
      >
        {text}
        {` (${count})`}
      </Text>
    </Layout.Group>
  </ButtonStyled>
);
